import React, { FC, useEffect, useState } from "react";
import useSWR from "swr";

import { useNavigate } from "react-router";
import { getSignOutUrls } from "../../apis/get-sign-out-urls";

import Loader from "../../components/loader/loader";
import { DEFAULT_BETAPATH, DEFAULT_PATH, useReturnUrl } from "../../hooks/use-return-url";

const SingleSignOutPage: FC = () => {
  const navigate = useNavigate();
  const [loaded, setLoaded] = useState<number>(0);
  const { data: signOutUrls } = useSWR("get-sign-out-urls", getSignOutUrls);
  const { hashedReturnUrl, returnUrl } = useReturnUrl();

  useEffect(() => {
    let retries = 0;
    const timer: ReturnType<typeof setInterval> = setInterval(() => {
      if (signOutUrls?.length === loaded || retries >= 100) {
        if (returnUrl && returnUrl !== DEFAULT_PATH && returnUrl !== DEFAULT_BETAPATH) {
          window.location.href = returnUrl;
        } else {
          navigate("/signed-out");
        }
        if (timer) clearInterval(timer);
      }
      retries++;
    }, 100);

    return () => {
      if (timer) clearInterval(timer);
    };
  }, [signOutUrls, loaded, navigate, hashedReturnUrl, returnUrl]);

  return (
    <>
      <Loader />
      <div className="visibility-hidden">
        {signOutUrls?.map((signOutUrl: string, index) => (
          <img
            key={index}
            alt=""
            src={signOutUrl}
            onLoad={() => setLoaded(loaded + 1)}
            onError={() => setLoaded(loaded + 1)}
          />
        ))}
      </div>
    </>
  );
};

export default SingleSignOutPage;
